export const useEnv = (env: Recordable): ImportMetaEnv => {
  const ret: any = {};

  for (const envKey of Object.keys(env)) {
    let envValue = env[envKey];
    envValue = envValue === 'true' ? true : envValue === 'false' ? false : envValue;
    ret[envKey] = envValue;
  }
  return ret;
};
